import React from 'react';
import { WhatsappShareButton } from 'react-share';
import '../styles/MessageDisplay.css';

const ShareOnWhatsAppButton = ({ imageUrl, message }) => {
  const combinedMessage = `${message}\n${imageUrl}`;

  // const shareUrl = `whatsapp://send?text=${encodeURIComponent(combinedMessage)}`;
  const shareUrl = `whatsapp://send?text=${encodeURIComponent(message)}&media=${encodeURIComponent(imageUrl)}`;


  return (
    <div className="share-button-container py-5">
      {/* <img src={imageUrl} alt="Image" />
      <p>{message}</p> */}
      {/* <a href={shareUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-share-button">
        Share on WhatsApp
      </a> */}
    <WhatsappShareButton
      url={imageUrl}
      title={message}
      separator=" - "
      style={{
          backgroundColor: 'pink',
          color: 'black',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
        }}>
      Share on WhatsApp
    </WhatsappShareButton>
     
      {/* <WhatsappShareButton
        url={shareUrl}
        style={{
          backgroundColor: 'pink',
          color: 'black',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
        }}>
        Share on WhatsApp
      </WhatsappShareButton> */}

      {/* <WhatsappShareButton url={shareUrl} className="whatsapp-share-button">
        Share on WhatsApp
      </WhatsappShareButton> */}
    </div>
  );
};

export default ShareOnWhatsAppButton;


// import React from 'react';

// const ShareOnWhatsAppButton = ({ imageUrl, message }) => {
//   const handleShare = () => {
//     const combinedMessage = `${message}\n${imageUrl}`;
//     const shareUrl = `whatsapp://send?text=${encodeURIComponent(combinedMessage)}`;
//     window.open(shareUrl);
//   };

//   return (
//     <button className="whatsapp-share-button" onClick={handleShare}>
//       Share on WhatsApp
//     </button>
//   );
// };

// export default ShareOnWhatsAppButton;


// import React from 'react';
// import { WhatsappShareButton } from 'react-share';

// const ShareOnWhatsAppButton = ({ message }) => {
//   const shareUrl = `whatsapp://send?text=${encodeURIComponent(message)}`;

//   return (
//     <WhatsappShareButton url={shareUrl}>
//       Share on WhatsApp
//     </WhatsappShareButton>
//   );
// };

// export default ShareOnWhatsAppButton;
